const AlertTypeEnum = {
  AssetPrice  : 'Asset_Price',
  PositionMTM : 'Position_MTM',
  PortfolioMTM: 'Portfolio_MTM'
}
export default AlertTypeEnum
